//Imports
import React from "react";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Accueil from "./pages/Accueil";
import Projets from "./pages/AllProjects";
import Details from "./pages/ProjectDetailsPage";
import Contact from "./pages/Contact";
import Nouvelles from "./pages/Nouvelles";


//Création du composant
const App = () => {
 return(
    <Router>
      <Switch>
        <Route path="/" exact component={Accueil} />
        <Route path="/projets" exact component={Projets} />
        <Route path="/projet/:id" component={Details} />
        <Route path="/contact" exact component={Contact} />
        <Route path="/nouvelles" exact component={Nouvelles} />
        
      
      </Switch>
    </Router>
 )
}
//Export du composant
export default App;